import React, {useCallback, useEffect, useState} from 'react';
import {useProduct} from '@montana/containers/product';
import cx from 'clsx';

export interface IMeasurementPickerComponentProps {
    headline: string;
}

export const MeasurementPicker: React.FC<IMeasurementPickerComponentProps> = ({headline}) => {
    const { measurements, config, applyProductConfig, prices } = useProduct();
    const [showDepthMessage, setShowDepthMessage] = useState<boolean>(false);
    const [selectedMeasurement, setSelectedMeasurement] = useState<string>('');
    const elmRef = useCallback((elm: HTMLDivElement) => {
        if (!!elm && elm.parentElement !== null) {
            elm.style.left = ((elm.offsetWidth - elm.parentElement.offsetWidth) / 2) * -1 + 'px';
        }
    }, [config]);

    useEffect(() => {
        setShowDepthMessage(false);
        setSelectedMeasurement(measurements?.filter(entity => entity.seoFriendlyValue === config?.measurement)[0].displayValue ?? '');
    },[config]);

    useEffect(() => {
        if (prices?.depthMessage?.length) {
            setShowDepthMessage(true);
        } else {
            setShowDepthMessage(false);
        }
    },[prices])

    return (
        <div className="dimension-picker dimension-picker--content">
            <div className="dimension-picker__wrapper">
                <div className="dimension-picker__header">
                    <span className="dimension-picker__header--emphasized">{headline}:</span> {selectedMeasurement}
                </div>
                <ul className={cx('dimension-picker__list dimension-picker__list--text-label',
                    {
                        'dimension-picker__list--mobile-center': !!measurements && measurements.length < 5
                    })}>
                    {measurements?.map((option, index) =>
                        <li key={index} className={`dimension-picker__list-item ${config?.measurement === option.seoFriendlyValue? 'dimension-picker__list-item--active' : ''}`}>
                            <button
                                className="dimension-picker__option-default"
                                onClick={() => applyProductConfig({ ...config, measurement: option.seoFriendlyValue })}
                            >
                                <div className="dimension-picker__option-default-text">{option.displayValue}</div>
                            </button>
                            {
                                showDepthMessage && config?.measurement === option.seoFriendlyValue &&
                                <div ref={elmRef} className="dimension-picker__option-default-notification">{prices?.depthMessage}</div>
                            }
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};
